import { valueDisplay } from '../../../../models/valueDisplay.model';
import * as fromUsuarioSelect from './usuarioselect.accions';

export interface IvalueDisplay {
  valuedisplay: valueDisplay[],
  loaded: boolean;
  loading: boolean;
  error: any;
}

const stateInitial: IvalueDisplay = {
  valuedisplay: [],
  loaded: false,
  loading: false,
  error: null
}


export function valuedisplayreducer(
                state = stateInitial,
                action: fromUsuarioSelect.valuedisplayAcciones) : IvalueDisplay {
                  switch ( action.type) {
                    case fromUsuarioSelect.CARGAR_VALUEDISPLAY_USUARIOSELECT:
                      return {
                        ...state,
                        loaded: true,
                        error: null
                      }
                    case fromUsuarioSelect.CARGAR_VALUEDISPLAY_USUARIOSELECT_SUCCESS:
                      return {
                        ...state,
                        loading: false,
                        loaded:true,
                        valuedisplay: [...action.valuedisplay]
                      }
                    case fromUsuarioSelect.CARGAR_VALUEDISPLAY_USUARIOSELECT_FAIL:
                      return {
                        ...state,
                        loaded: false,
                        loading: false,
                        error: {
                          status: action.payload.status,
                          message: action.payload.messege
                        }
                      }
                    default:
                      return state;
                  }
                }




// WEBPACK FOOTER //
// ./src/pages/meseromesero/state/usuarioselect/usuarioselect.reducer.ts